import pinArt from "./pinArt";
import magnetic from "./magnetic";
import ferrofluid from "./ferrofluid";
import wave from "./wave";
import cymatics from "./cymatics";
import gravity from "./gravity";
import sound from "./sound";
import fractal from "./fractal";
import scan from "./scan";
import matter from "./matter";
import dimension from "./dimension";

export const MODES = [pinArt, magnetic, ferrofluid, wave, cymatics, gravity, sound, fractal, scan, matter, dimension];
export const defaults = (m) => Object.fromEntries(m.params.map((p) => [p.key, p.def]));
